import * as React from 'react'
import * as styles from './SchedioLogo.module.less'

export interface SchedioLogoProps {
	className?: string
	homeLink?: string
	logo?: any
	style?: React.CSSProperties
	title: React.ReactNode
}

export const SchedioLogo: React.FC<SchedioLogoProps> = (props) => {
	const { homeLink, logo, style, title } = props
	const className =
		props.className !== undefined
			? `${styles.schedioLogoContainer} ${props.className}`
			: styles.schedioLogoContainer

	return (
		<div className={className} id='logo' style={style}>
			<a className={styles.logo} href={homeLink || '/'}>
				{logo && <img alt='logo' src={logo} />}
				{title}
			</a>
		</div>
	)
}
